import axiosInstance from "../../../axiosInterceptor";



const icsSanAPIStats =
  "/san_api_stats";
const icsSanAPIGraph =
  "/san_api_graph";
const icsSanAPIPriorityValues = "/san_api_priority_values";
const roiCalculation = "/roi_calculation";

export const statsFunc = async (payload) => {
  try {
    const response=await axiosInstance.post(icsSanAPIStats, payload);
    const statsData = response.data;
    return statsData; 
  } catch (error) {
    throw new Error(error.message);
  }
};



export const priorityOptionsFunc = async (payload) => {
  try {
    const response=await axiosInstance.post(icsSanAPIPriorityValues, payload);
    const priorityOptions = response.data;
    return priorityOptions; 
  } catch (error) {
    throw new Error(error.message);
  }
};


export const graphDataFunc = async (payload) => {
  try {
    const response=await axiosInstance.post(icsSanAPIGraph, payload);
    const graphData = response.data;
    return graphData; 
  } catch (error) {
    return error;
    // throw new Error(error.message);
  }
};


export const roiCalculationFunc = async (payload) => {
  try {
    const response=await axiosInstance.post(roiCalculation, payload);
    const roiData = response.data;
    return roiData; 
  } catch (error) {
    return error;
    // throw new Error(error.message);
  }
};